import type { ComponentType } from 'react'
import type { SDIconProps } from '@/shared/icons/SDIcon'
import type { StatusTone } from '../../contractStatusTone'
import { ContractNumber, ContractNumberValue, StatusChip } from '../../styled-components'

interface StatusCellProps {
  label: string
  tone: StatusTone
  Icon: ComponentType<SDIconProps>
  numberLabel: string
  number: string
}

const StatusCell = ({ label, tone, Icon, numberLabel, number }: StatusCellProps) => (
  <>
    <StatusChip $tone={tone}>
      <Icon size={14} />
      {label}
    </StatusChip>
    <ContractNumber>
      {numberLabel} <ContractNumberValue>{number}</ContractNumberValue>
    </ContractNumber>
  </>
)

export default StatusCell
